<form [formGroup]="folioNumberForm">
  <div formArrayName="numbers" class="is-flex is-flex-wrap-wrap is-align-items-center">
    <div *ngFor="let _ of numbers.controls; let i = index"
         [formGroupName]="i"
         class="field m-2"
         style="position: relative">

      <input type="text" class="border-input pr-5" placeholder="Blatt-Nr." formControlName="number"
             [ngClass]="{'has-error': FormUtils.hasError(numbers.at(i).get('number'))}"/>

      <button *ngIf="numbers.length > 1" type="button"
              class="delete-button-inside"
              (click)="removeNumberField(i)"
              aria-label="Remove input"
              title="Remove input">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <!-- Add Button -->
    <div class="field m-2">
      <div class="control">
        <button type="button"
                class="button no-hover is-white"
                (click)="addNumberField()">
          <span class="icon is-small is-align-self-center">
            <svg xmlns="http://www.w3.org/2000/svg"
                 width="15.989"
                 height="15.989"
                 viewBox="0 0 15.989 15.989">
              <path id="Icon_awesome-plus"
                    data-name="Icon awesome-plus"
                    d="M14.846,8.531H9.707V3.392A1.142,1.142,0,0,0,8.565,2.25H7.423A1.142,1.142,0,0,0,6.281,3.392V8.531H1.142A1.142,1.142,0,0,0,0,9.673v1.142a1.142,1.142,0,0,0,1.142,1.142H6.281V17.1a1.142,1.142,0,0,0,1.142,1.142H8.565A1.142,1.142,0,0,0,9.707,17.1V11.957h5.139a1.142,1.142,0,0,0,1.142-1.142V9.673A1.142,1.142,0,0,0,14.846,8.531Z"
                    transform="translate(0 -2.25)"
                    fill="#707070"/>
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>

  <p *ngIf="displayAdditionalCostInformation" class="mb-3 warning">
    <span class="warning"><fa-icon [icon]="faInfoCircle"></fa-icon></span>
    Für den Fall, dass die Liegenschaft mehrere Grundbuchblätter umfasst, kostet jeder zusätzliche Grundbuchauszug 50%
    des Dokumentenpreises.
  </p>

  <div class="field">
    <div class="control promoted-checkbox">
      <input id="dataResearchCheckbox" type="checkbox" class="promoted-input-checkbox" formControlName="dataResearch"/>

      <label class="custom-checkbox-label is-size-6" for="dataResearchCheckbox"
             matTooltip="Bei der manuellen Eingabe der Grundstücksdaten ist die Qualitätskontrolle verpflichtend."
             [matTooltipDisabled]="!folioNumberForm.get('dataResearch')?.disabled">

        <img class="checkbox-icon"
             [src]="folioNumberForm.get('dataResearch')?.value ? 'assets/images/checkbox/checked.svg' : 'assets/images/checkbox/unchecked.svg'"
             alt="Checkbox icon"/>
        <span>
        Ich kenne die Grundstücksdaten nicht. Bitte recherchieren Sie gegen einen Aufpreis
        <span *ngIf="researchAmount">
          in Höhe von {{ researchAmount | currency: 'EUR' }}
        </span>
        für mich.
      </span>
      </label>
    </div>
  </div>
</form>
